import React from "react";
import middleware from "./middleware/middleware";
import AllPositionInPage from "../component/sections/position/manage/AllPositionInPage";
import ViewPosition from "../component/sections/position/manage/ViewPosition";
import AllMessage from "../component/sections/position/manage/AllMessage";
import AllPositionIndependentInSitePublisher from "../component/sections/position/independent/manage/AllPositions";
import ViewPositionIndependent from "../component/sections/position/independent/manage/ViewPosition";
import AllIndependentPositionMessage from "../component/sections/position/independent/manage/AllMessage";
import ManageReportPosition from "../component/sections/position/manage/ReportPosition";

const sitesRoutes = [
  {
    path: "/position/manage/page/:pageID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPositionInPage />,
        "AllPositionInPage"
      );
    },
    exact: true,
  },
  {
    path: "/position/manage/:positionID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewPosition />,
        "ViewPosition"
      );
    },
    exact: true,
  },
  {
    path: "/position/manage/:positionID/all-message",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllMessage />,
        "AllMessage"
      );
    },
    exact: true,
  },
  {
    path: "/position/manage/independent/publisher/:publisherID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPositionIndependentInSitePublisher />,
        "AllPositionIndependentInSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/position/manage/independent/:positionID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewPositionIndependent />,
        "ViewPositionIndependent"
      );
    },
    exact: true,
  },
  {
    path: "/position/manage/independent/:positionID/all-message",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllIndependentPositionMessage />,
        "AllIndependentPositionMessage"
      );
    },
    exact: true,
  },
  {
    path: "/positions/manage/report-position",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <ManageReportPosition />,
        "ManageReportPosition"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
